import { render, staticRenderFns } from "./schedulerDB.vue?vue&type=template&id=5546bd57&"
import script from "./schedulerDB.vue?vue&type=script&lang=js&"
export * from "./schedulerDB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports